module.exports = __webpack_public_path__ + "static/img/banner7.e139e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner7.jpg
// module id = YPyT
// module chunks = 1